import Head from 'next/head';

import Library from '../../components/Library';
import { pageTitle } from '../../components/shared/basic/customHead';

const LibraryPage = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('Library')}</title>
      </Head>
      <Library />
    </div>
  );
};

export default LibraryPage;
